// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__jLEd5","input":"checkbox_input__2s3kt","text":"checkbox_text__23RZJ","error":"checkbox_error__38GhB"};